import React, { useEffect } from 'react';
import bgImage from '../../assets/img/443994-engineering-drawing-architecture.jpg';
import { Helmet } from 'react-helmet';
import Header from '../../comp/Header';

function Ingenieria(props) {
  useEffect(() => {
    props.setBackgroundImage(bgImage);
  }, []);

  return (
    <div>
      <Helmet>
        <title>Enginios - Ingeniería</title>
        <meta name="description" content= "Somos ingenieros y ponemos a tu disposición nuestra experiencia para tus proyectos industriales, domésticos, reformas o mantenimiento. ¡Consultanos!"/>
        <meta name="keywords" content="Enginios ingenieria, Enginios reformas"/>
        <meta name="robots" content= "index, follow"/>
      </Helmet>
      <Header title="Ingeniería" />
      <div className="mainBlank">
        <main>
          <h2>Tu proyecto en buenas manos</h2>
          <p>Como ingenieros, ponemos a tu disposición nuestra experiencia en diseño industrial, reformas y mantenimiento de edificios.</p>
          <h2>MÁS INFORMACIÓN PRÓXIMAMENTE</h2>
        </main>
      </div>
    </div>
    
  );
};

export default Ingenieria